import React from "react";
import Box from "components/common/Box";

/**
 * Campaign banner from `productInfo.image_metadata` on the product-discount-offers API.
 * Desktop uses web; mobile uses mobile (falls back to web).
 */
const ProductInfoOfferBanner = ({ offer, isActive, sx }) => {
  if (!isActive) {
    return null;
  }

  const productInfo = offer?.productInfo || {};
  const desktopSrc = productInfo.webImageUrl || productInfo.mobileImageUrl;
  const mobileSrc = productInfo.mobileImageUrl || productInfo.webImageUrl;

  if (!desktopSrc && !mobileSrc) {
    return null;
  }

  return (
    <Box sx={sx}>
      {desktopSrc ? (
        <Box
          component="img"
          src={desktopSrc}
          alt=""
          sx={{
            display: { xs: "none", md: "block" },
            width: "100%",
            borderRadius: "20px",
            objectFit: "cover",
          }}
        />
      ) : null}
      {mobileSrc ? (
        <Box
          component="img"
          src={mobileSrc}
          alt=""
          sx={{
            display: { xs: "block", md: "none" },
            width: "100%",
            borderRadius: "16px",
            objectFit: "cover",
          }}
        />
      ) : null}
    </Box>
  );
};

export default ProductInfoOfferBanner;
